import { Icon } from '@iconify/react';
import { Button, Input, Link } from '@nextui-org/react';
import { useMutation } from '@tanstack/react-query';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { PasswordResetService } from '../../services/password-reset-service';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const requestResetMutation = useMutation({
    mutationFn: async (email: string) => {
      return await PasswordResetService.requestReset({ email });
    },
    onSuccess: () => {
      toast.success(
        'If an account exists with this email, you will receive password reset instructions.'
      );
      navigate('/forgot-password/check-email', {
        state: { email },
        replace: true,
      });
    },
    onError: (error: any) => {
      console.error('Password reset request failed:', error);
      toast.error(
        error.response?.data?.detail ||
          'Failed to send reset email. Please try again.'
      );
    },
  });

  const isDisabled = !email.trim() || !email.includes('@');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isDisabled) {
      requestResetMutation.mutate(email);
    }
  };

  return (
    <div className="flex h-full w-full items-center justify-center px-8 pt-20">
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-large">
        <div className="flex flex-col items-center pb-6">
          <p className="text-xl font-medium">{'Mentora LiFT'}</p>
          <p className="text-small text-default-500">Reset your password</p>
        </div>

        <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
          <Input
            label="Email Address"
            placeholder="Enter your email"
            type="email"
            variant="bordered"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isRequired
          />

          <Button
            color="primary"
            type="submit"
            isLoading={requestResetMutation.isPending}
            isDisabled={isDisabled}
          >
            {requestResetMutation.isPending ? 'Sending...' : 'Send Reset Email'}
          </Button>
        </form>

        <div className="flex items-center justify-center">
          <Link className="text-default-500" href="/login" size="sm">
            <Icon icon="solar:arrow-left-linear" className="mr-1" />
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
